import React, { useEffect, useState } from "react";
import { Modal, Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import moment from "moment";
import { toast } from "react-toastify";
import { updateBooleanValue } from "../../../reducers/Snapshot";
import { useDispatch } from "react-redux";

const DepartureApprovalModal = (props) => {
  const dispatch = useDispatch();
  const [showModal, setShowModal] = useState(false);
  const [leaveData, setLeaveData] = useState({});
  const [reason, setReason] = useState(""); 

  useEffect(() => {
    setShowModal(props.showDepartStudent);
    setLeaveData(props.archiveLeaveData);
  }, [props]);

  let departure_date = new Date(props.archiveLeaveData.departure_students_data.planned_depart_date);
  const closeModal = () => {
    props.hideDepartStudentModal(false);
  };
console.log(props.archiveLeaveData ,"leaveDataleaveDataleaveDataleaveData")
  const handleSubmit = () => {
    const form_data = {
      border_leave_id: leaveData.border_leave_id,
      depart_status: "departed",
      border_leave_depart_stu_id: leaveData.departure_students_data.border_leave_depart_stu_id,
      student_id: leaveData.student_id,
      student_name: leaveData.leave_stu_data.student_name,
      planned_depart_date:leaveData?.departure_students_data?.planned_depart_date
      ,
      ...(leaveData?.is_host_approval === "rejected" && { sing_out_comment: reason }) 
    };
    if (new Date() >= departure_date) {
      props.DepartStuLeaveChange(form_data);
    } else {
      props.hideDepartStudentModal(false);
      dispatch(updateBooleanValue(true));
      toast.error("Your leave is not approved for this departure date", {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  };

  return (
    <>
      {leaveData?.is_host_approval === "rejected" ? (
        <Modal show={showModal} onHide={closeModal}>
          <Modal.Header closeButton>
            <Modal.Title>Departure Confirmation</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <h4 className="badge me-2 badge-light-danger w-100 d-flex justify-content-center align-items-center py-4" style={{fontSize: '16px'}} >Host has Rejected Leave</h4>
            <span className="d-flex justify-content-center align-items-center py-4 border-bottom" style={{fontSize: '16px'}}>Are you sure you wish to sign this student out now?</span>
           <div className="form-group mt-3">
            <label className="mb-2">Add your reason</label>
            <textarea rows={4}
              type="text"
              className="form-control h-auto"
              value={reason}
              onChange={(e) => setReason(e.target.value)} 
            ></textarea>
           </div>
          </Modal.Body>
          <Modal.Footer>
            <Button className="btn-sm" variant="secondary" onClick={closeModal}>
              Cancel
            </Button>
            <Button
              className="btn-sm px-10"
              variant="primary"
              onClick={handleSubmit}
              disabled={props.isLoading}
            >
              Ok
            </Button>
          </Modal.Footer>
        </Modal>
      ) : (
        <Modal show={showModal} onHide={closeModal}>
          <Modal.Header closeButton>
            <Modal.Title>Departure Confirmation</Modal.Title>
          </Modal.Header>
          <Modal.Body>Are you sure you wish to sign this student out now?</Modal.Body>
          <Modal.Footer>
            <Button className="btn-sm" variant="secondary" onClick={closeModal}>
              Cancel
            </Button>
            <Button
              className="btn-sm px-10"
              variant="primary"
              onClick={handleSubmit}
              disabled={props.isLoading}
            >
              Ok
            </Button>
          </Modal.Footer>
        </Modal>
      )}
    </>
  );
};

export default DepartureApprovalModal;